export default "__VITE_ASSET__Di5IjHgq__"